import React from 'react';
import Layout from 'layout';

import { authenticationService } from 'auth/authenticationService.js'


import {  
    Box,
    Button,Paper,
    Typography

} from '@mui/material';

class Administracion extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      consulta_listos_para_pago:null,
      consulta_listos_para_pago_forzar: null
    };

    this.handleConsulta = this.handleConsulta.bind(this);

  }
  componentDidMount(){
    // let local_html = JSON.parse(localStorage.getItem('dashboard'));
    // if(local_html){
    //   this.setState({html:local_html})
    // }
    // else{

    // }
  }
  handleConsulta(event, params){
    authenticationService.fetchApi({
    url:'/permisos/consultar_pagos/',
    method: 'POST',
    body: JSON.stringify(params),
    })
    .then(result=>{
      if(params.tipo==='listo_para_pago'){
        this.setState({consulta_listos_para_pago: result.cuantos});
      }
      else if(params.tipo==='pagados'){
        this.setState({consulta_pagados: result.cuantos});
      }
      else if(params.tipo==='incompletos'){
        this.setState({consulta_incompletos: result.cuantos});
      }
      else if(params.tipo==='pagados_parcial'){
        this.setState({consulta_pagados_parcial: result.cuantos});
      }
    })
    .catch(err=>{

    });
  }
  render() {
    return (
      <Layout title='Inicio'>
        <Box>
          <Typography variant='h6'>
            Administración
          </Typography>

          <Paper>
            <Box p={1}>
              <Button color='primary'
                      variant='outlined'
                      onClick={event=>this.handleConsulta(event,{tipo: 'listo_para_pago',estado_consolidado:1})}
                      >
                  Consultar solo listos para Pago
              </Button>
            </Box>
            <Box p={1}>
              Cuantos se procesan: {this.state.consulta_listos_para_pago}
            </Box>
          </Paper>

          <Paper>
            <Box p={1}>
              <Button color='primary'
                      variant='outlined'
                      onClick={event=>this.handleConsulta(event,{tipo: 'incompletos', estado_consolidado:3})}
                      >
                  Consultar los incompletos
              </Button>
            </Box>
            <Box p={1}>
              Cuantos se procesan: {this.state.consulta_incompletos}
            </Box>
          </Paper>

          <Paper>
            <Box p={1}>
              <Button color='primary'
                      variant='outlined'
                      onClick={event=>this.handleConsulta(event,{tipo: 'pagados', estado_consolidado:4})}
                      >
                  Consultar de nuevo los pagados
              </Button>
            </Box>
            <Box p={1}>
              Cuantos se procesan: {this.state.consulta_pagados}
            </Box>
          </Paper>

          <Paper>
            <Box p={1}>
              <Button color='primary'
                      variant='outlined'
                      onClick={event=>this.handleConsulta(event,{tipo: 'pagados_parcial', estado_consolidado:6})}
                      >
                  Consultar los pagados con 1ª cuota (falta 2ª)
              </Button>
            </Box>
            <Box p={1}>
              Cuantos se procesan: {this.state.consulta_pagados_parcial}
            </Box>
          </Paper>
        </Box>
      </Layout>
    );
  }
}

export default Administracion;
